// Wait for jQuery to be ready
window.$ = window.jQuery = require('jquery');

$(document).ready(function() {
    // Only run on MYOB company file select page
    if (!$('#company_file').length) {
        return;
    }

    var $companySelect = $('#company_file');
    var $versionInput = $('#product_version');
    var $nameInput = $('#company_file_name');
    var $form = $companySelect.closest('form');

    // Update version and name when company is selected
    function updateFields() {
        var $selected = $companySelect.find('option:selected');
        var version = $selected.data('version') || '';
        var name = $selected.data('name') || '';

        $versionInput.val(version);
        $nameInput.val(name);
        $versionInput.toggleClass('is-invalid', !version);
    }

    // Bind events
    $companySelect.on('change', updateFields);

    // Initial update
    updateFields();

    // Form validation
    $form.on('submit', function(e) {
        if (!$versionInput.val() || !$nameInput.val()) {
            e.preventDefault();
            alert('Please select a company file');
            $companySelect.focus();
        }
    });
});
